<template>
  <img
    v-if="adults && hasChildren"
    src="@/assets/images/family.svg"
    class="icon"
    width="19"
    height="15"
  />
  <img
    v-else-if="isOneAdultOnly"
    src="@/assets/images/adult.svg"
    class="icon"
    width="6"
    height="19"
    alt=""
  />
  <img
    v-else-if="isAdultsOnly"
    src="@/assets/images/adults.svg"
    class="icon"
    width="13"
    height="19"
    alt=""
  />
  <img
    v-else-if="isAdultsGroup"
    src="@/assets/images/group.svg"
    class="icon"
    width="18"
    height="19"
    alt=""
  />
  <img
    v-else-if="isChildrenOnly"
    src="@/assets/images/children.svg"
    class="icon"
    width="15"
    height="19"
    alt=""
  />
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({})
class BookingPartyIcon extends Vue {
  @Prop()
  adults: number

  @Prop()
  childAges: number[]

  get hasChildren() {
    return this.childAges.length > 0
  }

  get isOneAdultOnly() {
    return this.adults === 1 && !this.hasChildren
  }

  get isAdultsOnly() {
    return this.adults < 4 && !this.hasChildren
  }

  get isAdultsGroup() {
    return this.adults >= 4 && !this.hasChildren
  }

  get isChildrenOnly() {
    return this.adults === 0 && this.hasChildren
  }
}

export default toNative(BookingPartyIcon)
</script>
